import { tableRowBehavior } from './tableRowBehavior';
/**
 * @description
 * Basic behavior for static table - a static tabular structure containing one or more rows that each contain one or more cells; it is not an interactive widget
 * @specification
 * Adds role='table'.
 * Applies 'tableRowBehavior' for 'row' child component.
 */

export var tableBehavior = function tableBehavior() {
  return {
    attributes: {
      root: {
        role: 'table'
      }
    },
    childBehaviors: {
      row: tableRowBehavior
    }
  };
};